module.exports = __webpack_public_path__ + "static/media/3.7ac9cf82.png";